import { forwardRef } from 'react';
import { ChartHR } from '@/entities/heart-rate';
import useHrChart from './useHrChart';

export type HrChartHandle = {
  handleClickArrowButton: (isNext: boolean) => void;
};

export type HrChartProps = {
  studyId: string;
  profileId: string;
  timezoneOffset: number;
  ecgDataMap: any;
};

/**
 * Heart-rate trend chart for the rhythm events tab. Takes the chart ref, tab key, series data and the currently selected strip from useHrChart and renders ChartHR at a fixed minimum width with the study's timezone offset.
 *
 * @returns The rendered heart-rate chart.
 */
const HrChart = forwardRef<HrChartHandle, HrChartProps>(
  ({ studyId, profileId, timezoneOffset, ecgDataMap }, ref) => {
    const { chartHrRef, keyRecoil, dataChart, updatedSelectedStrip } = useHrChart(
      { studyId, profileId, timezoneOffset, ecgDataMap },
      ref,
    );

    return (
      <ChartHR
        ref={chartHrRef}
        idHtmlChart="rhythm-events-hr-chart-container"
        keyRecoil={keyRecoil}
        dataChart={dataChart}
        updatedSelectedStrip={updatedSelectedStrip}
        timezoneOffset={timezoneOffset}
        minWidth={1395}
      />
    );
  },
);

export default HrChart;
